<template>
    <div class="d-inline pr-2 pl-2">
        <b-button variant="primary" class="mb-2 w-100" @click="openModal">
            <i class="fas fa-folder-plus"></i>
            Add to hashtag set
        </b-button>
        <b-modal
            size="lg"
            ref="update-hashtagset-modal"
            id="update-hashtagset-modal"
            centered
            title="Add to existing hashtag set"
        >
            <!-- Page preloader -->
            <PagePreloader v-if="!modalisready">hashtag sets</PagePreloader>

            <!-- Page preloader -->
            <PagePreloader v-if="modalisloading">hashtags</PagePreloader>

            <!-- Error management -->
            <CustomAlerts :errors="errors"></CustomAlerts>

            <!-- Displayer -->
            <template v-if="modalisready">
                <!-- If we do have hashtags -->
                <template v-if="hasHashtags">
                    <form method="POST" v-on:submit.prevent="updateHashtagSet">
                        <b-form-group label-cols="4" label-cols-lg="2" label="Hashtag Set">
                            <b-form-select
                                v-model="form.set"
                                :options="select"
                                autocomplete="off"
                            ></b-form-select>
                        </b-form-group>

                        <b-form-group
                            label-cols="4"
                            label-cols-lg="2"
                            label="Hashtags to add"
                            label-for="input-default"
                        >
                            <b-form-textarea
                                id="hashtags"
                                name="hashtags"
                                placeholder="Enter hashtags here..."
                                rows="3"
                                max-rows="6"
                                :value="form.hashtags"
                                v-model="form.hashtags"
                            ></b-form-textarea>
                        </b-form-group>
                        <input type="submit" class="d-none" :disabled="modalisloading" />
                    </form>
                </template>

                <!-- If we DON'T currently have hashtag sets -->
                <template v-if="!hasHashtags">
                    <InfoBox
                        text="It looks like you don't yet have any hashtag sets. Create one now using the 'Create new hashtag set' button"
                    ></InfoBox>
                </template>
            </template>

            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-button
                    type="submit"
                    variant="success"
                    @click="updateHashtagSet"
                    :disabled="modalisloading"
                    v-if="hasHashtags"
                >
                    Add to existing hashtag set
                </b-button>
                <!-- Button with custom close trigger value -->
                <b-button variant="outline-secondary" @click="hide()"> Cancel </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
// Defaults
import axios from "axios";
// Components
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
import InfoBox from "@/view/content/Custom/InfoBox.vue";
// Mixins
import axiosErrorManagement from "@/mixins/axiosErrorManagement";

export default {
    name: "buttonAddHashtagSet",
    mixins: [axiosErrorManagement],
    components: {
        CustomAlerts,
        PagePreloader,
        InfoBox,
    },
    props: {
        propHashtags: String,
    },
    data() {
        return {
            // Errors
            errors: [],

            // Displayers
            modalisready: false,

            // Preloaders
            modalisloading: false,

            // Form
            form: {
                set: "",
                hashtags: "",
            },

            // Data
            existingHashtagSets: [],
            select: [],
        };
    },
    methods: {
        getInitial() {
            // Perform get
            axios
                .get("myhashtagsv2/basic")
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Set
                    this.existingHashtagSets = data;

                    // Reset the select
                    this.select = [];

                    // Check
                    if (data.length > 0) {
                        data.forEach((currentItem) => {
                            this.select.push({
                                text: currentItem.title + " - " + currentItem.count + " hashtags ",
                                value: currentItem.id,
                            });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    this.modalisready = true;
                });
        },

        // Open modal
        openModal() {
            // Refresh errors
            this.errors = [];

            // Load
            this.getInitial();

            // Set data
            this.form.hashtags = this.propHashtags;

            // Open modal
            this.$refs["update-hashtagset-modal"].show();
        },

        // Perform query
        updateHashtagSet() {
            // Reset errors
            this.errors = [];

            // Set loader
            this.modalisloading = true;

            // Perform post
            axios
                .post("myhashtagsv2/add", {
                    id: this.form.set,
                    hashtags: this.form.hashtags,
                })
                .then((response) => {
                    // Make pretty
                    var data = response.data;

                    // Check status
                    if (data.status == "OK") {
                        // Open modal
                        this.$refs["update-hashtagset-modal"].hide();
                        this.$emit("emitPassMessage", data.messages);
                    }

                    // Check for errors
                    if (data.messages.length > 0) {
                        data.messages.forEach((item) => {
                            this.errors.push({ type: item.type, message: item.message });
                        });
                    }
                })
                .catch((error) => {
                    this.errors.push(this.handleAxiosErrors(error));
                })
                .finally(() => {
                    // Remove preloader
                    this.modalisloading = false;
                });
        },
    },
    computed: {
        hasHashtags() {
            return this.existingHashtagSets.length;
        },
    },
};
</script>
